export default {
	section_banner: {
		title: {
			one: 'About Your',
		},
		main_title: {
			one: 'Business',
		},
		paragraph: {
			one: 'We take care of security and management. You just need to worry about operations.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	wallet_sec: {
		label: 'Hassle Free Way',
		title: {
			one: 'Store Management Is',
			two: 'Also',
			three: 'Automatic',
		},
		paragraph: {
			one: 'Are you still manually managing it every day? Just use JPWorldPay, and everything will be handled automatically. From smart transactions to real-time tracking, JPWorldPay simplifies your daily financial tasks so you can focus on what matters most.',
			two: 'With JPWorldPay, automation meets efficiency. Say goodbye to repetitive tasks and manual errors-our platform streamlines your workflow, keeps records organized, and ensures your finances stay on track.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	corps_dwn: {
		label: 'Easy & Smooth Process',
		title: {
			one: 'Sign Up & Complete Store',
			two: 'Registration',
		},
		paragraph:
			'Enjoy a free franchise management program with lifetime access and no usage fees. JPWorldPay offers powerful tools to help you manage your franchise operations efficiently-completely free of charge. From tracking sales to organizing data, it is all included with zero hidden costs.',
		cta_buttons: {
			one: 'Create Store',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
